<template>
  <v-container>
    <!-- <v-row>
      <v-col>
       <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kalibrasi</v-card-title>
          <v-divider class="mx-2 mt-n2"></v-divider> -->
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row class="my-n8">
                  <v-col>
                    <v-select
                      :items="stations"
                      label="Stasiun"
                      v-model="selectStation"
                      return-object
                      :rules="nameRules"
                      @change="change(selectStation)"
                      class="float-right"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <!-- Firmware Version -->
                    <v-row>
                      <v-col class="my-n4">
                        <v-text-field
                          v-model="version"
                          :rules="numberOnly"
                          label="New Version Number(ESP12)"
                          required
                        ></v-text-field>
                        <v-btn color="primary" class="float-right" @click="saveVersion(selectStation)">
                          SAVE
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Firmware Version 32-->
                    <v-row>
                      <v-col class="my-n4">
                        <v-text-field
                          v-model="version32"
                          :rules="numberOnly"
                          label="New Version Number (ESP32)"
                          required
                        ></v-text-field>
                        <v-btn color="primary" class="float-right" @click="saveVersion32(selectStation)">
                          SAVE
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Recap Time -->
                    <v-row>
                      <v-col class="my-n4">
                        <v-dialog
                          ref="dialog"
                          v-model="modal2"
                          :return-value.sync="recapTime"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="recapTime"
                              label="Waktu Rekap"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="recapTime"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modal2 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(recapTime)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                        <v-btn color="primary" class="float-right" @click="saveRecap(selectStation)">
                          SAVE
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Periodical Info -->
                    <v-row>
                      <v-col class="my-n4">
                        <v-text-field
                          v-model="period"
                          :rules="nameRules"
                          label="Periode Info ESP12 (menit)"
                          required
                        ></v-text-field>
                        <v-btn color="primary" class="float-right" @click="saveInfo(selectStation)">
                          SAVE
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Periodical Info ESP32-->
                    <v-row>
                      <v-col class="my-n4">
                        <v-text-field
                          v-model="periodESP32"
                          :rules="nameRules"
                          label="Periode Info ESP32(menit)"
                          required
                        ></v-text-field>
                        <v-btn color="primary" class="float-right" @click="saveInfo32(selectStation)">
                          SAVE
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Battery Scale -->
                    <v-row>
                      <v-col class="my-n4">
                        <v-text-field
                          v-model="batScale"
                          :rules="number"
                          label="Battery Scale"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    
                    

                  </v-col>

                  <v-divider
                    class="d-none d-sm-flex"
                    vertical
                  ></v-divider>

                  <v-col
                    cols="12"
                    sm="6"
                  >

                  <v-row>
                    <v-col class="my-n4">
                      <v-text-field
                        v-model="currentVersion"
                        label="Current Version Number"
                        readonly
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- mm/tick -->
                  <v-row>
                    <v-col
                      class="my-n4"
                    >
                      <v-text-field
                        v-model="tickmm"
                        :rules="number"
                        label="mm/tick"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>


                  <!-- Rain Stop Time -->
                  <v-row>
                    <v-col
                      class="my-n4"
                    >
                      <v-text-field
                        v-model="stoptime"
                        :rules="number"
                        label="Rain Stop Time (s)"
                        required
                      ></v-text-field>
                      <v-btn color="primary" class="float-right" @click="saveStop(selectStation)">
                        SAVE
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Rain Start Tick -->
                  <v-row>
                    <v-col
                      class="my-n4"
                    >
                      <v-text-field
                        v-model="starttick"
                        :rules="number"
                        label="Rain Start Tick"
                        required
                      ></v-text-field>
                      <v-btn color="primary" class="float-right" @click="saveStart(selectStation)">
                        SAVE
                      </v-btn>
                    </v-col>
                  </v-row>


                  <!-- SD Card Save Time -->
                  <v-row>
                    <v-col
                      class="my-n4"
                    >
                      <v-text-field
                        v-model="SDSaveTime"
                        :rules="number"
                        label="SD Card Save Time"
                        required
                      ></v-text-field>
                      <v-btn color="primary" class="float-right" @click="saveSDCard(selectStation)">
                        SAVE
                      </v-btn>
                    </v-col>
                  </v-row>

                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      color="success darken-1"
                      class="float-right"
                      @click="save(selectStation)"
                    >
                      Save
                    </v-btn>
                    <v-btn color="error">
                      Cancel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider class="mx-2 my-4"></v-divider>

            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="CRC32"
                  label="CRC32 ESP12"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="blue darken-1"
                  class="float-left mt-2"
                  @click="saveCRC12"
                  dark
                >
                  Save
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="CRC32ESP32"
                  label="CRC32 ESP32"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="blue darken-1"
                  class="float-left mt-2"
                  @click="saveCRC32"
                  dark
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="kuota"
                  label="Cek Kuota"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="blue darken-1"
                  class="float-left mt-2"
                  @click="saveKuota"
                  dark
                >
                  Save
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="nomor"
                  label="Cek Nomor"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="blue darken-1"
                  class="float-left mt-2"
                  @click="saveNomor"
                  dark
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="deviceVersion"
                  :items-per-page="5"
                  :calculate-widths="true"
                  item-key="station"
                  class="elevation-1"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                >
                <template v-slot:[`item.latestVersion`]="{ item }">
                  <span v-if="item.latestVersion==undefined">
                    N/A
                  </span>
                  <span v-else>
                    {{item.latestVersion}}
                  </span>
                </template>
                <template v-slot:[`item.currentVersion`]="{ item }">
                  <span v-if="item.currentVersion==undefined">
                    N/A
                  </span>
                  <span v-else>
                    {{item.currentVersion}}
                  </span>
                </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-divider class="mx-2 my-4"></v-divider>

            <h2>Request Log</h2>
            <v-row>
              <v-col>
                <v-select
                  :items="stationsLog"
                  label="Stasiun"
                  v-model="selectStationLog"
                  return-object
                  :rules="nameRules"
                  class="float-left"
                  @change="getFileNames(selectStationLog);getFile(selectStationLog)"
                ></v-select>
                <v-btn class="ma-3 primary" @click="requestLog(selectStationLog)">Request</v-btn>
              </v-col>
              <v-col>
                <v-select
                  :items="fileNames"
                  label="Files"
                  v-model="selectFile"
                  return-object
                  :rules="nameRules"
                  class="float-left"
                ></v-select>
                <v-btn class="ma-3 primary" @click="requestFile(selectStationLog,selectFile)">Request</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span v-if="fileText">
                  <v-btn class="float-end mb-2" color="primary" @click="download(fileNameServer,fileText)"><v-icon left>mdi-download</v-icon>Download</v-btn>
                </span>
              </v-col>
            </v-row>

            <v-divider class="mx-2 my-4"></v-divider>
            <!-- Upload Phone number -->
            <h2> Upload Phone Number</h2>
            <v-row>
              <v-col cols="12" sm="6">
                <v-file-input
                  v-model="file"
                  label="Upload File"
                  prepend-icon="mdi-file-upload"
                  accept=".csv"
                >
                  <template v-slot:append-outer>
                    <v-btn
                      color="primary"
                      @click="upload(file)"
                    >
                      Upload
                    </v-btn>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
        <!-- </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"

import csvtojson from 'csvtojson'
import moment from 'moment'

export default {
  data: () => ({
    chip:null,
    downloadErrFile:null,
    fileText:null,
    fileNameServer:null,
    selectFile:null,
    fileNames:[],
    selectStationLog:null,
    stationsLog:[],
    valid:false,
    stations:[],
    nameRules: [
      v => !!v || 'This Field is required'
    ],
    selectStation:null,
    recapTime: null,
    modal2:false,
    period: null,
    batScale:null,
    number: [
      v => !!v || 'This Field is required',
      v => /^[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
    ],
    numberOnly: [
      v => !!v || 'This Field is required',
      v => /^[0-9]*$/.test(v) || 'Only number is allowed'
    ],
    tickmm: null,
    stoptime:null,
    starttick:null,
    file:null,
    version:null,
    currentVersion:null,
    headers: [
      {
        text: 'Stasiun',
        align: 'start',
        value: 'station',
      },
      { text: 'Current Version', value: 'currentVersion' },
      { text: 'Latest Version', value: 'latestVersion'},
      { text: 'CRC32', value:'CRC32'},
      { text: 'Device ID', value:'id'},
      { text: 'Feeding ID', value:'feedingID'},
      { text: 'New ID', value:'newID'},
    ],
    deviceVersion:[],
    CRC32:'',
    CRC32ESP32:'',
    nomor:'',
    kuota:'',
    periodESP32:null,
    SDSaveTime:null,
    version32:null,
    offset:null,
  }),
  mounted () {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    let loader = this.$loading.show()
    var settingRef = db.collection('setting')
    settingRef.orderBy("latestVersion","desc").orderBy("station","desc").onSnapshot((collectionSnapshot) => {
      this.stations=[]
      this.stationsLog=[]
      this.data=[]
      collectionSnapshot.forEach((doc) => {
          this.stations.push({text: doc.data().station, value: doc.id});
          this.data.push({id: doc.id, ...doc.data()});
          this.stationsLog.push({text: doc.data().station, value: doc.id});
      });
      this.stations.push({text:'All', value:'all'})
      this.deviceVersion=this.data
      this.CRC32=this.data[0].CRC32
      this.CRC32ESP32= this.data[0].CRC32ESP32
      loader.hide()
      // this.loadingData=false
    })
  },
  methods: {
    updateTime (time) {
      return moment.unix(time).utcOffset(this.offset).format("DD/MMM/YY HH:mm")
    },
    change(station) {
      if (station.value!='all') {
        this.index = this.data.findIndex(x => x.id === station.value);
        this.recapTime = this.data[this.index].recap
        this.period = this.data[this.index].infotime
        this.tickmm = this.data[this.index].mmpertick
        this.starttick = this.data[this.index].starttick
        this.stoptime = this.data[this.index].stoptime
        this.batScale = this.data[this.index].batScale
        this.version = this.data[this.index].latestVersion
        this.currentVersion = this.data[this.index].currentVersion
        this.version32 = this.data[this.index].latestVersion32
        this.periodESP32 = this.data[this.index].infotime32
        this.SDSaveTime = this.data[this.index].saveSDCard
        this.chip = this.data[this.index].chip
      }
    },
    save(station) {
      if (station.value!='all') {
        if (this.$refs.form.validate()) {
          let loader = this.$loading.show()
          var settingRef = db.collection('setting').doc(station.value)
          settingRef.update({
            recap: this.recapTime,
            infotime: this.period,
            mmpertick: this.tickmm,
            starttick: this.starttick,
            stoptime: this.stoptime,
            batScale: this.batScale,
            latestVersion: this.version,
            saveSDCard:this.SDSaveTime,
            infotime32:this.periodESP32,
            latestVersion32: this.version32,
          }).then(()=>{
            loader.hide()
          }).catch(()=> {
            loader.hide()
          })
        }
      }
    },
    saveCRC12() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {CRC32:this.CRC32})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveCRC32() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {CRC32ESP32:this.CRC32ESP32})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveKuota() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {Kuota:this.kuota})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveNomor() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {Nomor:this.nomor})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveStop(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {stoptime:this.stoptime})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveStart(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {starttick:this.starttick})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveInfo(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {infotime:this.period})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveSDCard(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {saveSDCard:this.SDSaveTime})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveInfo32(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {infotime32:this.periodESP32})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveRecap(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {recap:this.recapTime})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveVersion32(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {latestVersion32:this.version32})
        }
        
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveVersion(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('setting').doc(this.stations[i].value), {latestVersion:this.version})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    async requestLog(station) {
      console.log(station.value)
      let loader = this.$loading.show()
      await db.collection('setting').doc(station.value).update({
        requestFile:'1'
      }).then(()=> {
        loader.hide()
      })
    },
    async getFileNames(station) {
      this.fileNames=[]
      await db.collection('filesErr').doc(station.value).get().then((res)=> {
        csvtojson()
        .fromString(res.data().fileNames)
        .then((csvRow)=>{ 
          csvRow.forEach((data)=> {
            this.fileNames.push({
              value:data.name,
              text: `${this.updateTime(parseInt(data.name))} - ${Number(data.size/1024).toFixed(2)}KB`
            })
          })
          this.fileNames.sort((a,b) => {
            return b.value-a.value
          })
          console.log(this.fileNames)
        })
      }).catch((err)=> {
        console.log(err)
      })
    },
    async requestFile(station,time) {
      let loader = this.$loading.show()
      await db.collection('setting').doc(station.value).update({
        requestFileTime:time.value
      }).then(()=> {
        loader.hide()
      })
    },
    async getFile(station) {
      await db.collection('filesErr').doc(station.value).get().then((res)=> {
        this.fileText=res.data().data
        this.fileNameServer = res.data().title
        csvtojson()
        .fromString(res.data().fileNames)
        .then((csvRow)=>{ 
          this.downloadErrFile=csvRow
        })
      }).catch((err)=> {
        console.log(err)
      })
    },
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    upload(file) {
      let loader = this.$loading.show()
      if (file) {
        const fileRef = db.collection('setting').doc('phoneNumber')
        const reader = new FileReader()
        reader.onload = (e) => {
          const csv = e.target.result
          csvtojson({delimiter:'auto'})
          .fromString(csv)
          .then((jsonObj)=> {
            console.log(jsonObj)
            const phoneNumber = jsonObj.map((data)=> {
              return {
                ICCID:data.ICCID,
                MSISDN:data.MSISDN,
              }
            })
            fileRef.set({
              phoneNumber:phoneNumber
            }).then(()=> {
              loader.hide()
            })
          })
        }
        reader.readAsText(file)
      } else {
        alert('Please select a file')
        loader.hide()
      }
    },
  }
}
</script>